// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"206":"colors","226":"streaming","319":"mobs-habblet","446":"profile-habblet","641":"badges-habblet"}[chunkId] || chunkId) + "." + {"206":"2f27f4c8","226":"7235adaa","319":"5bcd6d7d","446":"17cc0ffc","641":"397fede8","668":"1f56f260"}[chunkId] + ".js";
};